import React from 'react';

const ConfigurationsPage: React.FC = () => {
    return <h1>Configurations</h1>;
};

export default ConfigurationsPage;
